/*
  Padel USA — Best Price Guarantee request form (sections/price-match-form_custom.liquid).
  1. Prefills "Product at Padel USA" from ?product= so a PDP link can deep-link to the form.
  2. Shows the order-number field only when "Yes, I've ordered" is picked.
  Progressive: without this file every field stays visible and the form still submits.
  Dossier: custom-code-padelusa/features/best-price-guarantee-page.md
*/
(() => {
  const init = (form) => {
    if (form.dataset.pmfReady) return;
    form.dataset.pmfReady = 'true';

    const product = form.querySelector('[data-pmf-product]');
    const fromUrl = new URLSearchParams(window.location.search).get('product');
    if (product && fromUrl && !product.value) product.value = fromUrl.slice(0, 200);

    const order = form.querySelector('[data-pmf-order]');
    const radios = form.querySelectorAll('[data-pmf-status]');
    if (!order || !radios.length) return;

    const sync = () => {
      const ordered = form.querySelector('[data-pmf-status="ordered"]:checked');
      order.hidden = !ordered;
    };
    radios.forEach((radio) => radio.addEventListener('change', sync));
    sync();
  };

  const run = () => document.querySelectorAll('[data-price-match-form]').forEach(init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
})();
